import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿El material es físico o digital?',
    a: 'Es 100% digital en formato PDF de alta calidad. Podés descargarlo inmediatamente después de la compra y leerlo en tu celular, tablet, computadora o imprimirlo si lo preferís.'
  }, {
    q: '¿Para qué edades están pensados los ejercicios?',
    a: 'La guía abarca ejercicios y planificaciones adaptables para categorías infantiles, principalmente desde los 6 hasta los 12 años (décima, novena y octava división).'
  }, {
    q: '¿Cómo recibo el acceso?',
    a: 'Una vez procesado el pago, recibirás automáticamente un correo electrónico con los enlaces de descarga de la guía principal y todos los bonos exclusivos.'
  }, {
    q: '¿Sirve si recién empiezo a dar clases?',
    a: '¡Totalmente! Es ideal para profes que recién arrancan porque te da una estructura clara y probada para que no tengas que inventar nada desde cero. Te dará mucha seguridad frente al grupo.'
  }, {
    q: '¿Cuáles son los medios de pago?',
    a: 'Podés abonar con tarjeta de crédito, débito o Mercado Pago. El pago es procesado de forma 100% segura.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 px-4 bg-brand-dark" data-id="element-73">
      <div className="max-w-3xl mx-auto" data-id="element-74">
        <div className="text-center mb-12" data-id="element-75">
          <h2 className="text-4xl font-display text-brand-cream mb-4 uppercase" data-id="element-76">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-77">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-card border border-brand-mint/10 rounded-xl overflow-hidden" data-id="element-78">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-79">
                <span className="font-bold text-brand-cream pr-4" data-id="element-80">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-brand-mint transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-81" />
              </button>
              <AnimatePresence data-id="element-82">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-83">
                    <div className="px-6 pb-5 text-brand-cream/70 text-sm leading-relaxed border-t border-brand-mint/5 pt-4" data-id="element-84">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}